import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { addService } from 'slice/serviceSlice';
import { useNavigate } from 'react-router-dom';

const Add = () => {
    const [name, setName] = useState('');
    const [image, setImage] = useState(null);
    const [pdfFile, setPdfFile] = useState(null);

    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { loading } = useSelector((state) => state.service);

    const handleSubmit = (e) => {
        e.preventDefault();
        const formData = new FormData();
        formData.append('name', name);
        if (image) formData.append('image', image);
        if (pdfFile) formData.append('pdfFile', pdfFile);

        dispatch(addService(formData));
        setTimeout(() => navigate('/khajuraho/services'), 1000);
    };

    return (
        <div className="container-fluid mt-5">
            <div className="mainheadig mx-4">
                <h4 className="text-white font-weight-bold">Add New Service</h4>
            </div>
            <form onSubmit={handleSubmit} className="bg-white p-4 mx-4 mt-5 rounded shadow">
                <div className="row">
                    <div className="col-sm-12">
                        <label className="adminlables">
                            Service Name
                            <input type="text" value={name} className="form-control" onChange={(e) => setName(e.target.value)} required />
                        </label>
                    </div>
                    <div className="col-sm-12 mt-3">
                        <label className="adminlables">
                            Image
                            <input type="file" accept="image/*" className="form-control" onChange={(e) => setImage(e.target.files[0])} required />
                        </label>
                    </div>
                    <div className="col-sm-12 mt-3">
                        <label className="adminlables">
                            PDF File (Optional)
                            <input type="file" accept="application/pdf" className="form-control" onChange={(e) => setPdfFile(e.target.files[0])} />
                        </label>
                    </div>
                </div>
                <div className="mt-5 text-right">
                    <button className="btn btn-lg addbtn" disabled={loading}>{loading ? 'Adding...' : 'Add Service'}</button>
                </div>
            </form>
        </div>
    );
};

export default Add;
